import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  HostListener,
  AfterViewInit,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from '@modules/shared/services/common.service';
import { DownloadService } from '@modules/shared/services/download-file.service';
import { CONVERSION_MULTIPLIERS, KEYBOARD_KEYS } from '@constants/constant';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  MUSIC_PLAYER_CONST,
  PURCHASE_MASTER_DATA_TEXT,
  MUSIC_VOLUME_STORAGE_KEY,
  GET_VOLUME_FROM_STORAGE
} from '@components/player-modal/constant';
import { Application } from '@enums/application.enums';
import moment from 'moment';
import { SharedModule } from '@modules/shared/shared.module';
import { PAYMENT_FOR_TYPE } from '@constants/constant';
import { AuthService } from '@core/auth.service';
import { LoginDialogComponent } from '@shared/components/login-dialog/login-dialog.component';
import { ShareDialogService } from '@shared/services/share-dialog.service';
import { SHARED_DIALOG_CONSTS } from '@shared/components/shareddialog/shareddialog.constants';
import { getSharePortfolioMsg } from '@modules/edit-preference/components/portfolio/portfolio.utils';
import { PORTFOLIO_CONSTS } from '@constants/constant';
import { ApiCallService } from '@services/api-call.service';
import { API_URLS } from '@core/api-url.enum';
import { PortfolioRecordPlayService } from '@services/portfolio-record-play.service';
import { MinimizedPlayerService } from '@modules/shared/services/minimized-player.service';
import { MediaService } from '@modules/shared/services/media.service';
import cloneDeep from 'lodash/cloneDeep';
import { parseReleaseDate, generateRandomId } from '@utils/common.utils';
import { STEP_1_BASIC_INFO_CONSTS } from '@modules/edit-preference/components/portfolio/components/add-edit-album-portfolio/step-1-basic-info/step-1-basic-info.fields';
import { PortfolioUnlockService } from '@modules/shared/services/portfolio-unlock.service';
import { PURCHASE_TEXT_MAP } from '@modules/edit-preference/components/portfolio/portfolio.contants';
import { PORTFOLIO_TITLE_HEADING_MAP } from '@modules/edit-preference/components/portfolio/components/portfolio-banner-view/portfolio-banner-view.constants';
import { LOCKED_POST_MESSAGES } from '@modules/dashboard/constants/home-strings.constant';
import { LOYALTY_POINTS_TEXT } from '@modules/wallet/component/loyalty-points/loyalty-points.constants';
import {
  mergePortfolioMediaUnlockedThrough,
  type PortfolioMediaUnlockedThrough
} from '@models/portfolio-media-unlocked-through.interface';

export interface LockedThrough {
  subscription?: Array<{ sk: string; pk: string; title?: string }>;
  individual?: {
    individual_price?: number | string;
    loyalty_points?: number;
  };
  nft?: string[];
}

export interface MusicItem {
  audioUrl: string;
  previewImageUrl?: string;
  albumTitle?: string;
  songTitle?: string;
  dateOfRelease?: string | number; // Can be string (year) or number (epoch)
  isLocked?: boolean;
  lock_through?: LockedThrough;
  duration?: number;
  showTime?: boolean;
  canPreview?: boolean;
  download_url?: string;
  unlocked_through?: PortfolioMediaUnlockedThrough;
  pk?: string;
  sk?: string;
}

interface MusicModalInitialState {
  userSubscriptionList?: any[];
  pUserSubscriptionList?: any[];
  audioUrl?: string;
  previewImageUrl?: string;
  buttonColor?: string;
  closeButtonColor?: string;
  progressBarColor?: string;
  musicList?: MusicItem[];
  currentIndex?: number;
  albumTitle?: string;
  songTitle?: string;
  dateOfRelease?: string;
  lock_through?: LockedThrough;
  isLocked?: boolean;
  userProfile?: any;
  portfolioType?: string;
  isMyProfile?: boolean;
  allowMinimizePlayer?: boolean;
  masterData?: any;
  portfolioCreatorUserName?: string;
  portfolioTypeId?: string;
  isIndividualPortfolio?: boolean;
  onPurchaseSubscription?: (music: any) => void;
  onPurchaseIndividual?: (music: any) => void;
  onPurchaseNft?: (music: any) => void;
}

@Component({
  selector: 'app-music-player-modal',
  templateUrl: './music-player-modal.component.html',
  styleUrls: ['./music-player-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, CurrencyPipe, SharedModule]
})
export class MusicPlayerModalComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('audioPlayer', { static: false })
  audioPlayer: ElementRef<HTMLAudioElement>;

  @ViewChild('unlockModal') unlockModal: any;

  @Input() buttonColor: string = '#00BFFF';
  @Input() closeButtonColor: string = '#00BFFF';
  @Input() progressBarColor: string = '#00b6ea';

  userSubscriptionList: any[] = [];

  musicList: MusicItem[] = [];
  currentIndex: number = Application.ZERO;
  allowMinimizePlayer: boolean = true;
  audioElement: HTMLAudioElement | null = null;
  isPlaying: boolean = false;
  currentTime: number = Application.ZERO;
  actualDuration: number = Application.ZERO;
  duration: number = Application.ZERO;
  volume: number = Application.ONE;
  isMuted: boolean = false;
  playbackRate: number = Application.ONE;
  playbackRates: number[] = [0.5, 0.75, 1, 1.25, 1.5, 2];
  showSpeedMenu: boolean = false;
  showVolumeSlider: boolean = false;
  private rafId: number | null = null;
  private modalHideSubscription: Subscription | null = null;

  isLocked: boolean = false;
  lockedThrough: LockedThrough | null = null;
  userProfile: any = null;
  musicId: string = '';
  musicSK: string = '';
  isMyProfile: boolean = false;
  private destroy$ = new Subject<void>();
  MUSIC_PLAYER_CONST = MUSIC_PLAYER_CONST;
  initialState: any = null;
  paymentForType = PAYMENT_FOR_TYPE;
  currentMusic: any = null;
  Application = Application;
  isLoadingAudio: boolean = false;
  portfolioType: string = PORTFOLIO_CONSTS.TYPE.MUSIC;
  PORTFOLIO_CONSTS = PORTFOLIO_CONSTS;
  readonly descriptionMaxLength: number = Application.FIVE_HUNDRED;
  isMobile: boolean = false;
  isReleaseYearType: boolean = false;
  private backdropObserver: MutationObserver | null = null;
  private isMinimizing: boolean = false;
  private playSessionId: string | null = null;
  private playLastRecordedTime: number = Application.ZERO;
  masterData: any = null;
  PURCHASE_MASTER_DATA_TEXT = PURCHASE_MASTER_DATA_TEXT;
  PURCHASE_TEXT_MAP = PURCHASE_TEXT_MAP;
  selectedItem: any = null;
  unlockModalHeader: string = '';
  pUserSubscriptionList: any[] = [];
  onPurchaseSubscription?: (music: any) => void;
  onPurchaseIndividual?: (music: any) => void;
  onPurchaseNft?: (music: any) => void;
  PORTFOLIO_TITLE_HEADING_MAP = PORTFOLIO_TITLE_HEADING_MAP;
  readonly LOCKED_POST_MESSAGES = LOCKED_POST_MESSAGES;
  readonly LOYALTY_POINTS_TEXT = LOYALTY_POINTS_TEXT;
  readonly LOYALTY_POINTS_AMOUNT_SUFFIX = LOYALTY_POINTS_TEXT.POINTS_SUFFIX;
  portfolioTypeId: string = '';
  portfolioCreatorUserName: string = '';
  isIndividualPortfolio: boolean = false;

  constructor(
    private readonly modalService: BsModalService,
    public readonly cs: CommonService,
    public modalRef: BsModalRef,
    private readonly downloadService: DownloadService,
    public readonly authService: AuthService,
    private readonly apiCallService: ApiCallService,
    private readonly cdr: ChangeDetectorRef,
    private readonly minimizedPlayerService: MinimizedPlayerService,
    private readonly mediaService: MediaService,
    private readonly portfolioUnlockService: PortfolioUnlockService,
    private readonly shareDialogService: ShareDialogService,
    private readonly portfolioRecordPlayService: PortfolioRecordPlayService,
    private currencyPipe: CurrencyPipe
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser) {
      this.isMobile = window.innerWidth <= Application.SEVEN_SIXTY_EIGHT;
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth <= Application.SEVEN_SIXTY_EIGHT;
        this.cdr.detectChanges();
      });

      // Load saved volume from localStorage
      this.loadSavedVolume();

      const initialState = this.modalService?.config
        ?.initialState as MusicModalInitialState;

      this.resetState();

      // Subscribe to video unmute events - pause music player when video is unmuted
      this.mediaService.videoUnmuted$
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          if (this.isPlaying && this.audioElement) {
            this.audioElement.pause();
          }
          // Also pause all ngx-audio-player instances when video is unmuted
          this.mediaService.pauseAllNgxAudioPlayers();
        });

      if (initialState) {
        this.isLocked = initialState.isLocked || false;
        this.lockedThrough = initialState.lock_through || null;
        this.userProfile = initialState.userProfile || null;
        this.portfolioType =
          initialState.portfolioType || PORTFOLIO_CONSTS.TYPE.MUSIC;
        this.isMyProfile = initialState.isMyProfile || false;
        this.onPurchaseSubscription = initialState.onPurchaseSubscription;
        this.onPurchaseIndividual = initialState.onPurchaseIndividual;
        this.onPurchaseNft = initialState.onPurchaseNft;
        this.pUserSubscriptionList = initialState.pUserSubscriptionList || [];
        this.initialState = initialState;
        this.userSubscriptionList = initialState.userSubscriptionList || [];
        this.masterData = initialState.masterData || null;
        this.portfolioCreatorUserName =
          initialState.portfolioCreatorUserName ||
          this.userProfile?.user_name ||
          '';
        this.portfolioTypeId = initialState.portfolioTypeId || '';
        this.isIndividualPortfolio =
          initialState.isIndividualPortfolio ?? false;

        if (
          initialState.musicList &&
          initialState.musicList.length > Application.ZERO
        ) {
          const originalCurrentIndex =
            initialState.currentIndex !== undefined
              ? initialState.currentIndex
              : Application.ZERO;
          const originalCurrentMusic =
            originalCurrentIndex < initialState.musicList.length
              ? initialState.musicList[originalCurrentIndex]
              : null;

          this.musicList = initialState.musicList.filter(
            (item: any) => item.showTime && item.file
          );

          if (this.musicList.length > Application.ZERO) {
            if (originalCurrentMusic && originalCurrentMusic.showTime) {
              // Find the index of the original current music in the filtered list
              const filteredIndex = this.musicList.findIndex(
                (item: any) =>
                  item === originalCurrentMusic ||
                  (item.audioUrl === originalCurrentMusic.audioUrl &&
                    item.songTitle === originalCurrentMusic.songTitle)
              );
              this.currentIndex =
                filteredIndex >= Application.ZERO
                  ? filteredIndex
                  : Application.ZERO;
            } else {
              this.currentIndex = Application.ZERO;
            }
          } else {
            this.currentIndex = Application.ZERO;
          }

          this.loadCurrentMusic();

          const minimizedState = this.minimizedPlayerService.getState();
          if (minimizedState.playSessionId != null) {
            this.playSessionId = minimizedState.playSessionId;
          }
          if (minimizedState.playLastRecordedTime != null) {
            this.playLastRecordedTime = minimizedState.playLastRecordedTime;
          }
        }
      }

      if (this.modalRef?.onHide) {
        this.modalHideSubscription = this.modalRef.onHide.subscribe(() => {
          // Don't clear minimized player if we're intentionally minimizing
          if (!this.isMinimizing) {
            this.restoreBodyScroll();
            this.closeModal();
          } else {
            // Reset the flag after handling the hide event
            this.isMinimizing = false;
            this.restoreBodyScroll();
          }
        });
      }

      if (this.cs.isWhiteLabelWeb) {
        this.progressBarColor = 'var(--configThemeColor)';
      }
    }

    this.cs.closeMusicPlayerModal
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) this.closeModal();
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.audioPlayer?.nativeElement) {
        this.audioElement = this.audioPlayer.nativeElement;
        this.setupAudioElement();
      }
    }, 100);
  }

  private get isEngagable(): boolean {
    return (
      this.currentMusic?.pk &&
      this.currentMusic?.sk &&
      !this.isMyProfile
    )
  }

  setupAudioElement() {
    if (!this.audioElement || !this.cs.isBrowser) return;

    this.audioElement.currentTime = Application.ZERO;
    this.audioElement.muted = false;
    // Use saved volume instead of always resetting to 1
    this.audioElement.volume = this.volume;
    this.audioElement.playbackRate = Application.ONE;

    this.audioElement.load();

    if ('mediaSession' in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: this.currentMusic?.songTitle || '',
        artist: '',
        album: this.currentMusic?.albumTitle || '',
        artwork: [
          {
            src: this.currentMusic?.previewImageUrl,
            sizes: '96x96',
            type: 'image/webp'
          }
        ]
      });
    }

    if (
      this.audioElement.duration &&
      !isNaN(this.audioElement.duration) &&
      isFinite(this.audioElement.duration)
    ) {
      this.duration = this.audioElement.duration;
    }

    this.audioElement.play().catch(() => {});
  }

  onAudioLoadedMetadata() {
    if (this.audioElement) {
      const newDuration = this.audioElement.duration;
      if (newDuration && !isNaN(newDuration) && isFinite(newDuration)) {
        this.duration = newDuration;
      }
      this.isLoadingAudio = false;
    }
  }

  onAudioLoadStart() {
    this.isLoadingAudio = true;
  }

  onAudioError() {
    this.isLoadingAudio = false;
  }

  onAudioTimeUpdate() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
    }
    this.rafId = requestAnimationFrame(() => {
      if (this.audioElement) {
        this.currentTime = this.audioElement.currentTime;
        const state = this.minimizedPlayerService.getState();
        if (state.isMinimized) {
          this.minimizedPlayerService.updateState({
            currentTime: this.currentTime,
            isPlaying: this.isPlaying,
            audioElement: this.audioElement
          });
        }
      }
      this.rafId = null;
    });
  }

  onAudioPlay() {
    this.ensurePlaySession();
    this.isPlaying = true;
    const state = this.minimizedPlayerService.getState();
    if (state.isMinimized) {
      this.minimizedPlayerService.updateState({
        isPlaying: true,
        audioElement: this.audioElement,
        playSessionId: this.playSessionId ?? undefined,
        playLastRecordedTime: this.playLastRecordedTime
      });
    }
    // Notify that music player started - this will mute any unmuted videos
    this.mediaService.notifyMusicPlayerStarted();
    this.mediaService.muteAllUnmutedVideos();
    // Also pause all ngx-audio-player instances when music player starts
    this.mediaService.pauseAllNgxAudioPlayers();
  }

  onAudioPause() {
    if (this.audioElement && this.playSessionId) {
      const currentTimeSec = this.audioElement.currentTime;
      this.sendRecordPlay(currentTimeSec);
      const state = this.minimizedPlayerService.getState();
      if (state.isMinimized) {
        this.minimizedPlayerService.updateState({
          playSessionId: this.playSessionId ?? undefined,
          playLastRecordedTime: this.playLastRecordedTime
        });
      }
    }
    this.isPlaying = false;
    const state = this.minimizedPlayerService.getState();
    if (state.isMinimized) {
      this.minimizedPlayerService.updateState({
        isPlaying: false,
        audioElement: this.audioElement
      });
    }
  }

  onAudioEnded() {
    if (this.audioElement && this.playSessionId) {
      const currentTimeSec = this.audioElement.currentTime;
      this.sendRecordPlay(currentTimeSec);
    }
    if (this.hasNextMusic() && !this.isLocked) {
      setTimeout(() => {
        this.playNextMusic();
      }, Application.INTERVAL_TWO_THOUSAND);
    }
  }

  onAudioVolumeChange() {
    if (this.audioElement) {
      this.volume = this.audioElement.volume;
      this.isMuted = this.audioElement.muted;
    }
  }

  onAudioRateChange() {
    if (this.audioElement) {
      this.playbackRate = this.audioElement.playbackRate;
    }
  }

  togglePlayPause() {
    if (this.isLocked && !this.currentMusic?.canPreview) return;
    if (this.audioElement) {
      if (this.isPlaying) {
        this.audioElement.pause();
      } else {
        this.audioElement.play();
      }
    }
  }

  onAudioClick(event: MouseEvent) {
    if (this.isLocked && !this.currentMusic?.canPreview) return;
    const target = event.target as HTMLElement;
    if (
      target.closest('.video-controls') ||
      target.closest('.control-btn') ||
      target.closest('.progress-bar-container') ||
      target.closest('.close-button') ||
      target.closest('.subscription-option')
    ) {
      return;
    }
    this.togglePlayPause();
  }

  get showLockedContent(): boolean {
    if (!this.currentMusic?.canPreview && this.isLocked) return true;
    else if (
      this.currentMusic?.canPreview &&
      this.audioElement &&
      this.duration - (this.audioElement.currentTime || Application.ZERO) <
        Application.TWO &&
      this.isLocked
    )
      return true;
    else return false;
  }

  fastForward() {
    if (this.audioElement) {
      const newTime = Math.min(
        this.duration,
        this.currentTime + Application.FIFTEEN
      );
      this.audioElement.currentTime = newTime;
    }
  }

  rewind() {
    if (this.audioElement && this.duration) {
      const newTime = Math.max(
        Application.ZERO,
        this.currentTime - Application.THIRTY
      );
      this.audioElement.currentTime = newTime;
    }
  }

  playPreviousMusic() {
    if (this.hasPreviousMusic()) {
      this.sendRecordPlayForCurrentTrack();
      this.currentIndex--;
      this.currentMusic = null;
      setTimeout(() => {
        this.loadCurrentMusic();
      }, 10);
    }
  }

  playNextMusic() {
    if (this.hasNextMusic()) {
      this.sendRecordPlayForCurrentTrack();
      this.currentIndex++;
      this.currentMusic = null;
      setTimeout(() => {
        this.loadCurrentMusic();
      }, 10);
    }
  }

  hasPreviousMusic(): boolean {
    return (
      this.musicList.length > Application.ZERO &&
      this.currentIndex > Application.ZERO
    );
  }

  hasNextMusic(): boolean {
    return (
      this.musicList.length > Application.ZERO &&
      this.currentIndex < this.musicList.length - Application.ONE
    );
  }

  loadCurrentMusic() {
    if (this.musicList.length === Application.ZERO) return;

    const currentMusic = this.musicList[this.currentIndex];
    this.actualDuration = currentMusic?.duration || Application.ZERO;
    if (currentMusic) {
      this.playSessionId = null;
      this.playLastRecordedTime = Application.ZERO;

      if (this.audioElement) {
        this.audioElement.pause();
        this.audioElement.currentTime = Application.ZERO;
        this.currentTime = Application.ZERO;
        this.duration = Application.ZERO;
        this.isPlaying = false;
      }

      // Handle release_date (can be string year or number epoch)
      const parsed = parseReleaseDate(currentMusic.dateOfRelease);
      if (parsed.type === STEP_1_BASIC_INFO_CONSTS.RELEASE_TYPE_YEAR) {
        currentMusic.dateOfRelease = parsed.value as string;
        this.isReleaseYearType = true;
      } else if (parsed.type === STEP_1_BASIC_INFO_CONSTS.RELEASE_TYPE_DATE) {
        currentMusic.dateOfRelease = moment(
          new Date(parsed.value as number)
        ).format('MMM D, YYYY');
        this.isReleaseYearType = false;
      } else {
        currentMusic.dateOfRelease = '';
        this.isReleaseYearType = false;
      }
      this.isLocked = currentMusic?.isLocked || false;
      this.lockedThrough = currentMusic.lock_through || null;
      this.currentMusic = cloneDeep(currentMusic);
      this.callEngagementAPI();
      if (!this.isLocked || this.currentMusic?.canPreview) {
        this.isLoadingAudio = true;
        setTimeout(() => {
          if (this.audioPlayer?.nativeElement) {
            this.audioElement = this.audioPlayer.nativeElement;
            if (this.audioElement.src !== currentMusic.audioUrl) {
              this.audioElement.src = currentMusic.audioUrl;
            }
            this.setupAudioElement();
          }
        }, 100);
      }
    }
  }

  toggleMute() {
    if (this.audioElement) {
      this.audioElement.muted = !this.isMuted;
    }
  }

  toggleVolumeSlider() {
    this.showVolumeSlider = !this.showVolumeSlider;
    if (this.showSpeedMenu) {
      this.showSpeedMenu = false;
    }
  }

  onVolumeChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const newVolume = parseFloat(target.value);
    this.updateVolume(newVolume);
  }

  private updateVolume(newVolume: number) {
    if (this.audioElement) {
      this.audioElement.volume = newVolume;
      this.volume = newVolume;
      if (newVolume > 0 && this.isMuted) {
        this.audioElement.muted = false;
        this.isMuted = false;
      }
      this.saveVolume(newVolume);
    }
  }

  private loadSavedVolume() {
    if (this.cs.isBrowser) {
      this.volume = GET_VOLUME_FROM_STORAGE();
    }
  }

  private saveVolume(volume: number) {
    if (this.cs.isBrowser) {
      try {
        localStorage.setItem(MUSIC_VOLUME_STORAGE_KEY, volume.toString());
      } catch (error) {
        // If localStorage is not available, silently fail
      }
    }
  }

  setPlaybackRate(rate: number) {
    if (this.audioElement) {
      this.audioElement.playbackRate = rate;
      this.showSpeedMenu = false;
    }
  }

  toggleSpeedMenu() {
    this.showSpeedMenu = !this.showSpeedMenu;
    if (this.showVolumeSlider) {
      this.showVolumeSlider = false;
    }
  }

  seek(event: MouseEvent) {
    if (this.isLocked && !this.currentMusic?.canPreview) return;
    if (this.audioElement && event.target) {
      const progressBar = event.currentTarget as HTMLElement;
      const rect = progressBar.getBoundingClientRect();
      const percent = (event.clientX - rect.left) / rect.width;
      const newTime = percent * this.duration;
      const currentTimeBefore = this.audioElement.currentTime;
      if (
        this.playSessionId &&
        (currentTimeBefore - this.playLastRecordedTime) * CONVERSION_MULTIPLIERS.SECONDS_TO_MILLISECONDS > Application.ZERO
      ) {
        this.sendRecordPlay(currentTimeBefore, newTime);
      } else {
        this.playLastRecordedTime = newTime;
      }
      this.audioElement.currentTime = newTime;
    }
  }

  downloadVideo() {
    if (!this.authService.isLogin && this.isLocked) {
      this.loginDialog();
      return;
    }
    if (
      this.currentMusic?.download_url &&
      this.cs.isBrowser &&
      !this.isLocked
    ) {
      const fileExtension =
        this.currentMusic.download_url.split('.').pop() || 'mp3';

      let safeTitle = this.currentMusic.songTitle || `audio-${Date.now()}`;

      safeTitle = safeTitle
        .replace(/[<>:"/\\|?*]/g, '-')
        .replace(/_+/g, '-')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim();

      const fileName = `${safeTitle}.${fileExtension}`;

      this.downloadService.downloadFile(
        this.currentMusic.download_url,
        fileName
      );
    }
  }

  loginDialog(): void {
    this.modalService.show(LoginDialogComponent, {});
  }

  onShareClick(): void {
    this.shareModal();
  }

  shareModal(): void {
    if (!this.currentMusic?.sk || !this.userProfile) {
      return;
    }

    // Extract portfolioTypeId from SK if needed
    let portfolioTypeId: string | undefined;
    const skParts = this.currentMusic.sk.split('#');
    if (
      skParts.length >= Application.TWO &&
      skParts[Application.ZERO] === Application.PORTFOLIO
    ) {
      portfolioTypeId = skParts[Application.ONE];
    } else if (skParts.length >= Application.THREE) {
      portfolioTypeId = skParts[Application.TWO];
    }

    const { msg, url, userName } = getSharePortfolioMsg(
      this.userProfile,
      this.currentMusic.sk,
      this.portfolioType,
      portfolioTypeId
    );

    const modalInfo = Object.assign({
      isMyProfile: this.isMyProfile,
      gsi4pk: this.userProfile?.gsi4pk,
      firstName: this.userProfile?.first_name,
      lastName: this.userProfile?.last_name,
      pk: this.userProfile?.pk,
      sk: this.currentMusic.sk,
      sharingResource: SHARED_DIALOG_CONSTS.PORTFOLIO_SHARE,
      url,
      image:
        this.currentMusic?.previewImageUrl ||
        this.currentMusic?.cover_image_url ||
        '',
      username: userName,
      otherUserEmail: this.userProfile?.email,
      portfolioMsg: msg
    });

    this.shareDialogService.openShareDialog(modalInfo, {
      backdrop: 'static'
    });
  }

  formatTime(seconds: number): string {
    if (!seconds || isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  getProgressPercent(): number {
    if (!this.duration) return 0;
    return (this.currentTime / this.duration) * 100;
  }

  minimizeModal() {
    if (this.currentMusic && this.audioElement) {
      // Set flag to prevent closeModal from clearing minimized player state
      this.isMinimizing = true;

      const currentTime = this.audioElement.currentTime;
      if (this.playSessionId) {
        this.sendRecordPlay(currentTime);
      }

      // Capture current audio state before pausing
      const wasPlaying = this.isPlaying;

      // Pause the modal's audio - minimized player will take over
      if (this.audioElement && !this.audioElement.paused) {
        this.audioElement.pause();
      }

      // Update minimized player service with current state
      this.minimizedPlayerService.minimize(
        this.currentMusic,
        this.musicList,
        this.currentIndex,
        this.audioElement,
        wasPlaying,
        currentTime,
        this.duration,
        this.initialState,
        this.playSessionId ?? undefined,
        this.playLastRecordedTime
      );

      // Close the modal - the standalone minimized player will handle playback
      this.restoreBodyScroll();
      if (this.cs.isBrowser) {
        document.body.classList.remove('modal-open');
      }

      // Hide the modal - onHide will be triggered but won't clear minimized player
      this.modalRef.hide();
      this.cdr.detectChanges();
    }
  }

  maximizeModal() {
    // This method is called from the minimized player to restore the modal
    // The minimized player will handle opening the modal with the current state
    this.minimizedPlayerService.maximize();
  }

  closePlayerModalForLoyaltyPaymentRedirect(): void {
    this.modalRef.hide();
  }
  
  closeModal() {
    const currentTimeSec =
      this.audioElement?.currentTime ?? this.currentTime ?? Application.ZERO;
    if (this.playSessionId) {
      this.sendRecordPlay(currentTimeSec);
    }
    this.minimizedPlayerService.clear();
    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement.currentTime = Application.ZERO;
    }
    if (this.cs.isBrowser) {
      document.body.classList.remove('music-player-minimized');
    }
    this.restoreBodyScroll();
    this.modalRef.hide();
    this.modalService.hide();
  }

  private resetState() {
    this.audioElement = null;
    this.isPlaying = false;
    this.currentTime = Application.ZERO;
    this.duration = Application.ZERO;
    this.isMuted = false;
    this.playbackRate = Application.ONE;
    this.showSpeedMenu = false;
    this.showVolumeSlider = false;
    this.musicList = [];
    this.currentIndex = Application.ZERO;
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }

  private restoreBodyScroll() {
    if (this.cs.isBrowser && document.body) {
      document.body.classList.remove('modal-open');
    }
  }

  private callEngagementAPI(): void {
    if (!this.isEngagable || !this.authService.isLogin) return;

    const payload = {
      pk: this.currentMusic.pk,
      sk: this.currentMusic.sk
    };

    this.apiCallService
      .post(API_URLS.portfolioEngagement, payload, false)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {},
        error: () => {}
      });
  }

  private ensurePlaySession(): void {
    if (!this.playSessionId) {
      this.playSessionId = `session_${generateRandomId()}`;
      this.playLastRecordedTime = Application.ZERO;
    }
  }

  private sendRecordPlay(
    currentTimeSec: number,
    updateLastRecordedTo?: number
  ): void {
    if (!this.isEngagable || !this.playSessionId) return;

    const durationPlayedMs = Math.max(
      Application.ZERO,
      (currentTimeSec - this.playLastRecordedTime) * CONVERSION_MULTIPLIERS.SECONDS_TO_MILLISECONDS
    );
    this.playLastRecordedTime =
      updateLastRecordedTo !== undefined
        ? updateLastRecordedTo
        : currentTimeSec;
    this.portfolioRecordPlayService.recordPlay({
      pk: this.currentMusic.pk,
      sk: this.currentMusic.sk,
      duration_played: durationPlayedMs,
      session_id: this.playSessionId
    });
  }

  private sendRecordPlayForCurrentTrack(): void {
    const currentTimeSec =
      this.audioElement?.currentTime ?? this.currentTime ?? Application.ZERO;
    if (this.playSessionId) {
      this.sendRecordPlay(currentTimeSec);
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!this.cs.isBrowser) return;

    const target = event.target as HTMLElement;
    if (
      target.tagName === KEYBOARD_KEYS.INPUT ||
      target.tagName === KEYBOARD_KEYS.TEXTAREA ||
      target.isContentEditable
    ) {
      return;
    }

    event.preventDefault();
    switch (event.key) {
      case KEYBOARD_KEYS.ESCAPE:
        this.closeModal();
        break;
      case KEYBOARD_KEYS.SPACE:
        this.togglePlayPause();
        break;
      case KEYBOARD_KEYS.ARROW_LEFT:
        this.rewind();
        break;
      case KEYBOARD_KEYS.ARROW_RIGHT:
        this.fastForward();
        break;
    }
  }

  @HostListener('document:click', ['$event'])
  handleDocumentClick(event: MouseEvent) {
    if (this.showVolumeSlider && this.cs.isBrowser) {
      const target = event.target as HTMLElement;
      const volumeControl = target.closest('.volume-control');
      if (!volumeControl) {
        this.showVolumeSlider = false;
      }
    }
  }

  purchaseSubscription() {
    if (
      this.currentMusic?.unlocked_through?.hasOwnProperty(
        'is_outer_unlocked'
      ) &&
      !this.currentMusic?.unlocked_through?.is_outer_unlocked
    )
      return;

    if (this.onPurchaseSubscription) {
      this.onPurchaseSubscription(this.currentMusic);
    }
  }

  purchaseIndividualMusic() {
    if (
      this.currentMusic?.unlocked_through?.hasOwnProperty(
        'is_outer_unlocked'
      ) &&
      !this.currentMusic?.unlocked_through?.is_outer_unlocked
    )
      return;

    if (this.onPurchaseIndividual) {
      this.onPurchaseIndividual(this.currentMusic);
    }
  }

  purchaseNftMusic() {
    if (
      this.currentMusic?.unlocked_through?.hasOwnProperty(
        'is_outer_unlocked'
      ) &&
      !this.currentMusic?.unlocked_through?.is_outer_unlocked
    )
      return;

    if (this.onPurchaseNft) {
      this.onPurchaseNft(this.currentMusic);
    }
  }

  seeLessMore(): void {
    if (this.currentMusic?.description?.length) {
      this.currentMusic = {
        ...this.currentMusic,
        isMore: !this.currentMusic.isMore
      };
      this.cdr.detectChanges();
    }
  }

  get showOrBeforeLoyaltyInline(): boolean {
    return (
      (!!this.lockedThrough?.individual?.individual_price ||
        !!this.lockedThrough?.subscription?.length ||
        !!this.lockedThrough?.nft?.length) &&
      !!this.lockedThrough?.individual?.loyalty_points &&
      this.authService.isWhiteLabelWebsite()
    );
  }


  openUnlockCurrentMusicWithPoints(): void {
    if (!this.cs.isBrowser || !this.currentMusic) {
      return;
    }
    this.selectedItem = { ...this.currentMusic };
    this.cdr.detectChanges();
    this.unlockModal?.openUnlockWithPointsModal();
  }

  purchaseMasterData(event?: Event): void {
    if (!this.masterData || !this.masterData.isLocked) {
      return;
    }

    const config = this.getUnlockConfig();
    const handled = this.portfolioUnlockService.handleLockClick(
      this.masterData,
      event || new Event('click'),
      config
    );
    if (handled) {
      this.selectedItem = this.masterData;
      this.unlockModalHeader =
        'Unlock ' +
        this.portfolioType.charAt(0).toUpperCase() +
        this.portfolioType.slice(1).toLowerCase() +
        (this.portfolioType.toLowerCase() ===
        PORTFOLIO_CONSTS.TYPE.MUSIC.toLowerCase()
          ? MUSIC_PLAYER_CONST.SPACE_ALBUM
          : MUSIC_PLAYER_CONST.SPACE_SERIES);
    }
  }

  onPurchaseMasterIndividual(): void {
    this.portfolioUnlockService.purchaseIndividual(this.getUnlockConfig());
  }

  onPurchaseMasterSubscription(): void {
    this.portfolioUnlockService.purchaseSubscription(this.getUnlockConfig());
  }

  onPurchaseMasterNft(): void {
    this.portfolioUnlockService.purchaseNft(this.getUnlockConfig());
  }

  onPortfolioUnlockedWithPoints(): void {
    const item = this.selectedItem || this.masterData;
    if (!item?.sk) {
      return;
    }
    const unlocked = mergePortfolioMediaUnlockedThrough(item.unlocked_through, {
      is_unlocked: true
    });
    item.isLocked = false;
    item.unlocked_through = unlocked;
    if (this.masterData?.sk === item.sk) {
      this.masterData.isLocked = false;
      this.masterData.unlocked_through = unlocked;
    }
    if (this.currentMusic?.sk === item.sk) {
      this.currentMusic.isLocked = false;
      this.currentMusic.unlocked_through = unlocked;
      this.isLocked = false;
      this.lockedThrough = this.currentMusic.lock_through ?? null;
    }
    this.musicList?.forEach((m: MusicItem) => {
      if (m.sk === item.sk) {
        m.isLocked = false;
        m.unlocked_through = mergePortfolioMediaUnlockedThrough(m.unlocked_through, {
          is_unlocked: true
        });
      }
    });
    this.cdr.detectChanges();
  }

  private getUnlockConfig() {
    return {
      selectedItem: this.selectedItem || this.masterData,
      visitedUserProfile: this.userProfile,
      userSubscriptionList: this.userSubscriptionList,
      pUserSubscriptionList: this.pUserSubscriptionList,
      portfolioType: this.portfolioType,
      unlockModal: this.unlockModal,
      destroy$: this.destroy$,
      isIndividual: false,
      userId: this.userProfile?.user_name || this.userProfile?.email,
      portfolioTypeId: this.masterData?.sk
        ? this.cs.decodeToUTF(this.masterData.sk)
        : '',
      isAlbumLocking: true,
      onMusicPlayerModalClose: () => {
        this.closeModal();
      }
    };
  }

  get individualPurchaseText() {
    const price = this.currentMusic?.price ? this.currentMusic.price : this.lockedThrough?.individual?.individual_price;
    return PURCHASE_TEXT_MAP[this.portfolioType].SINGLE.INDIVIDUAL_PURCHASE + ' ' + this.currencyPipe.transform(price, this.currentMusic?.currency_symbol);
  }

  get hasIndividualPrice(): boolean {
    return !!this.currentMusic?.lock_through?.individual?.individual_price;
  }

  get hasSubscription(): boolean {
    return !!this.currentMusic?.lock_through?.subscription?.length;
  }

  get hasNft(): boolean {
    return !!this.currentMusic?.lock_through?.nft?.length;
  }

  get showOrBeforeSubscription(): boolean {
    return this.hasIndividualPrice && this.hasSubscription;
  }

  get showOrBeforeNft(): boolean {
    return (this.hasIndividualPrice || this.hasSubscription) && this.hasNft;
  }

  ngOnDestroy() {
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    if (this.modalHideSubscription) {
      this.modalHideSubscription.unsubscribe();
      this.modalHideSubscription = null;
    }

    if (this.backdropObserver) {
      this.backdropObserver.disconnect();
      this.backdropObserver = null;
    }

    this.destroy$.next();
    this.destroy$.complete();

    this.restoreBodyScroll();
  }
}
